import { render, staticRenderFns } from "./discountConfig.vue?vue&type=template&id=d3c05cfe&scoped=true&"
import script from "./discountConfig.vue?vue&type=script&lang=js&"
export * from "./discountConfig.vue?vue&type=script&lang=js&"
import style0 from "./discountConfig.vue?vue&type=style&index=0&id=d3c05cfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c05cfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VSelect,VTextField})
